import { Typography, Button, CircularProgress } from '@mui/material';
import directMessagesImage from '/static/images/direct-messages.png';
import { InboxViewModel } from './useInbox.viewModel';

type EnableDirectMessageProps = Pick<InboxViewModel, 'submitting' | 'dispatch'>;

export const EnableDirectMessage = ({
  submitting,
  dispatch,
}: EnableDirectMessageProps) => {
  return (
    <div className="h-[80vh] bg-white rounded-[20px] flex flex-col justify-center items-center gap-6 p-12">
      <img src={directMessagesImage} className="max-w-[265px]" />
      <div className="flex flex-col justify-center items-center gap-4">
        <Typography sx={{ fontSize: 36, fontWeight: 700, lineHeight: '44px' }}>
          Ready for direct messaging?
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '24px',
            textAlign: 'center',
          }}
        >
          Your subscribers wlll be able to send you direct messages and reply to
          stories.
        </Typography>
      </div>
      <Button
        variant="contained"
        onClick={() => dispatch({ type: 'submitEnable' })}
        disabled={submitting}
        className="w-full md:w-[340px]"
      >
        {submitting ? (
          <CircularProgress className="h-[20px] w-[20px]" />
        ) : (
          'Turn on Direct Messages'
        )}
      </Button>
    </div>
  );
};
